import styled from 'styled-components'
import MasterCard from "web/assets/images/master-card-icon.png";
import VisaCard from "web/assets/images/visa-card-icon.png";
import AmericanCard from "web/assets/images/american-express-icon.png";
import DiscoverCard from "web/assets/images/discover-card-icon.png";
import ClubCard from "web/assets/images/club-card-icon.png";
import JcbCard from "web/assets/images/jcb-card-icon.png";
import StepperImage from "web/assets/images/stepper-image.png";
// import StepperFirstBlueImage from "web/assets/images/first-step-blue.png";
const RegistrationStepper = styled.div`
  background-image: linear-gradient(to bottom, #fff, #ccc6c6);
  .step-number {
    font-family: "arialbold";
    font-size: 33px;
    margin-right: 4px;
  }

  .MuiStepLabel-iconContainer,
  .MuiStepConnector-root {
    display: none;
  }
  .MuiStepper-horizontal {
    background-image: linear-gradient(to bottom, #fff, #ccc6c6);
    .MuiStepLabel-active {
      color: #fff;
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.16);
      background-color: #0a5587;
      position: relative;
      margin-right: 14px;
      margin-left: 14px;
      padding: 0;
      background-image: none;
      ::after {
        content: "";
        display: inline-flex;
        width: 0;
        height: 0;
        border: 0 solid transparent;
        border-top-width: 24.5px;
        border-bottom-width: 24.5px;
        border-left: 14px solid #0a5587;
        position: absolute;
        right: -14px;
      }
      ::before {
        content: "";
        display: inline-flex;
        width: 0;
        height: 0;
        border: 0 solid #0a5587;
        border-top-width: 24.5px;
        border-bottom-width: 24.5px;
        border-left: 14px solid transparent;
        position: absolute;
        left: -14px;
      }
    }
  }
  .MuiStep-horizontal {
    flex: 1;
    text-align: center;
    padding: 0;
  }

  .MuiStepLabel-root {
    height: 49px;
    justify-content: center;
  }
  .MuiStep-completed {
    .MuiStepLabel-label {
      ::after {
        right: -16px;
      }
    }
  }
  .MuiStepLabel-label.MuiStepLabel-completed {
    color: #61ae24;
  }
  .MuiStepLabel-label {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: "latobold" !important;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.16);
    background-image: linear-gradient(to bottom, #fff, #ccc6c6);
    color: #6c6c6c;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
    position: relative;
    ::after {
      content: "";
      background-image: url(${StepperImage});
      display: inline-flex;
      width: 21px;
      height: 100%;
      position: absolute;
      background-repeat: no-repeat;
      right: 0;
      z-index: 1;
    }
    :last-child {
    }
  }
  .MuiStepLabel-labelContainer {
    height: 100%;
  }
  .MuiStepper-root {
    padding: 0;
    width: 100%;
    max-width: 1411px;
    margin: 0 auto;
    padding: 0 98px;
    > .MuiStep-horizontal:first-child {
      .MuiStepLabel-active {
        margin-left: 0;
        :before {
          display: none;
        }
      }
    }
  }
  @media (max-width: 1250px) {
    .MuiStepper-root {
      padding: 0 15px;
    }
  }
`;

const FormSection = styled.div`
 
  width: 100%;
  .label-color {
    color: #191819;
    font-size: 17px;
    font-family: "latoregular";
    p {
      margin-top: 0;
      margin-bottom: 12px;
    }
    .star {
      color: #a30202;
    }
  }
  .submitBtn {
    max-width: 151px;
    width: 100%;
    border-radius: 5px;
  }
  .app-input-text {
    margin-bottom: 24px;
    input {
      border-radius: 5px;
      border: solid 1px #87cdf1;
    }
  }
`;

const ImageSection = styled.div`
  flex: 1;
  padding: 30px 60px;
  display: flex;
  justify-content: center;
  align-items: baseline;
  img {
    position: sticky;
   
    width: 106%;
    top: 239px;
  }
  @media (max-width: 1250px) {
    img {
      left: -15px;
      width: 100%;
      padding-right: 46px;
    }
  }
  @media (max-width: 965px) {
    display: none;
  }
`;

const StepOneContainer = styled.div`
    display: flex;
    align-items: center;
`
const FormWrapper = styled.div`
  border-radius: 10px;
  background-color: #fff;
  padding: 26px;
  flex: 1;
  .select-height {
    min-height: 99px;
  }
  @media (max-width: 965px) {
    max-width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  position: absolute;
  bottom: 36px;
  width: calc(100% - 69px);

  .step-2 {
    bottom: 85px;
  }
  .submitBtn {
    margin-right: 15px;
  }
`;
const BackButtonWrapper = styled.div`
    padding-top: 20px;
    display: flex;
    align-items: center;
`
const SubHeading = styled.h3`
  font-size: 21px;
  text-align: left;
  font-family: "latobold";
  margin-bottom: 30px;
  width: 100%;
  position: relative;
  padding-left: 80px;
  .right-arrow {
    position: absolute;
    left: -15px;
    top: -12px;
  }
`;
const PromoCode = styled.h3`
  color: #505050;
  font-size: 22px;
  font-family: "latobold";
  margin-bottom: 30px;
  width: 100%;
`;
const StepTwoContainer = styled.div`
    display: flex;
`
const AccountTypeSection = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-radius: 20px 20px 0 0;
  background-color: #fff;
`;
const CardTypeSection = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-top: 0;
  background-color: #fff;
`;
const CardTypeSectionStripe = styled.div`
  flex: 1;
  border-top: 0;
  background-color: #fff;
  .pf {
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    width: 41px;
    height: 27px;
    :before {
      display: none;
    }
  }
  .pf-mastercard {
    background-image: url(${MasterCard});
  }
  .pf-visa {
    background-image: url(${VisaCard});
  }
  .pf-american-express {
    background-image: url(${AmericanCard});
  }
  .pf-discover {
    background-image: url(${DiscoverCard});
  }
  .pf-diners {
    background-image: url(${ClubCard});
  }
  .pf-jcb {
    background-image: url(${JcbCard});
  }
`;
const StepThreeContainer = styled.div`
  display: flex;
  .text-area-wrapper {
    .app-input-text {
      margin-bottom: 0;
    }
  }
`;

const BusinessInfoSection = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-radius: 0;
  border-top: 0;
  background-color: #fff;
`;
const StepFourContainer = styled.div`
  display: flex;
`;
const PaymentMethod = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-radius: 0;
  border-top: 0;
  background-color: #fff;
`;
const StepFiveContainer = styled.div`
    display: flex;
`;

const CreditCardSection = styled.div`
  flex: 1;
  padding: 30px 15px;
  border-radius: 0 0 20px 20px;
  border-top: 0;
  background-color: #fff;
`;

const SubHeading2 = styled.h5`
    font-size: 18px;
    padding: 0 15px;
    color: #505050;
`
const FormDetailWrapper = styled.div`
  max-width: 1411px;
  width: 100%;
  border-radius: 10px;
  box-shadow: 4px 5px 4px 0 rgba(0, 0, 0, 0.16);
  padding: 24px 24px 72px 24px;
  margin: 0 auto;
  .description {
    display: flex;
    align-items: center;
    h6 {
      font-size: 22px;
      color: #191819;
      line-height: 25px;
      font-family: "latobold";
      margin-bottom: 15px;
    }
    p {
      font-size: 18px;
      line-height: 22px;
      font-family: "latomedium";
      flex: 1;
      span {
        font-weight: bold;
      }
      :first-child {
        max-width: 150px;
      }
    }
  }
`;

const PromoCodeCheckbox = styled.div`
  padding : 0 15px;
`

const RegistrationWraper = styled.div`
  padding: 50px 0 20px;
  .form {
    min-width: auto;
    position: relative;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
    border-radius: 10px;
    padding-bottom: 52px;
  }
  @media (min-width: 594px) {
    padding: 20px 0;
    .form {
      min-width: 594px;
    }
  }
`;

const StepText = styled.div`
  display: grid;
  text-align: left;
  line-height: 17px;
`

const PromoCodeSection = styled.div`
  position: absolute;
  display: inline-flex;
  top: 40px;
  right: 15px;
  button {
    background: transparent;
    color: #61ae24;
    width: auto;
    text-decoration: underline;
  }
`;
export {
  RegistrationStepper,
  FormSection,
  ImageSection,
  StepOneContainer,
  FormWrapper,
  ButtonWrapper,
  BackButtonWrapper,
  SubHeading,
  StepTwoContainer,
  AccountTypeSection,
  CardTypeSection,
  StepThreeContainer,
  BusinessInfoSection,
  StepFourContainer,
  PaymentMethod,
  StepFiveContainer,
  CreditCardSection,
  SubHeading2,
  PromoCode,
  CardTypeSectionStripe,
  FormDetailWrapper,
  PromoCodeCheckbox,
  RegistrationWraper,
  StepText,
  PromoCodeSection,
};